import { render, staticRenderFns } from "./SalesTotalSalesByRegionBarChart.vue?vue&type=template&id=32a481f9"
import script from "./SalesTotalSalesByRegionBarChart.vue?vue&type=script&lang=ts"
export * from "./SalesTotalSalesByRegionBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports